module.exports = __webpack_public_path__ + "img/112031.31b48b86.png";